import { EnvironmentProviders, makeEnvironmentProviders } from '@angular/core';
import { provideState } from '@ngrx/store';
import { provideEffects } from '@ngrx/effects';

import { reducers, effects, featureKey } from './store';

export function ProvideDiseaseProfilesNgrx(): EnvironmentProviders {
  return makeEnvironmentProviders([provideState(featureKey, reducers), provideEffects(effects)]);
}
